import Vue from 'vue'
import Vuex from 'vuex'
import detail from './modules/detail'
import app from './modules/app'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    detail,
    app,
  },
  getters: {
    innerPageImages: state => state.detail.innerPageImages,
    mp3Play: state => state.detail.mp3Play,
    detailColors: state => state.detail.detailColors,
    appColors: state => state.detail.appColors,
  },
  state: {},
  mutations: {},
  actions: {},
})

export default store
